import React from "react";
import { CalendarRange } from "lucide-react";
import { Button } from "@/components/ui/button";
import DatePickerField from "@/components/DatePickerField";

export const AdminDateRangeControls = ({ dateFrom, dateTo, setDateFrom, setDateTo, showAll, testIdPrefix }) => (
  <div className="flex flex-wrap items-end gap-2" data-testid={`${testIdPrefix}-date-controls`}>
    <div><div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">From</div><DatePickerField value={dateFrom} onChange={setDateFrom} testId={`${testIdPrefix}-date-from`} className="w-[145px]" /></div>
    <div><div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">To</div><DatePickerField value={dateTo} onChange={setDateTo} testId={`${testIdPrefix}-date-to`} className="w-[145px]" /></div>
    <Button type="button" variant="ghost" onClick={showAll} className="h-11 rounded-sm text-xs" data-testid={`${testIdPrefix}-show-all`}>
      <CalendarRange className="w-4 h-4 mr-1.5" /> Show all
    </Button>
  </div>
);